export default {"src":"/_next/static/media/6-people-logo.ec87e8c7.svg","height":28,"width":63};